module.exports = __webpack_public_path__ + "img/logo2.20eef96a.png";